import { useState } from "react";
import { AlertTriangle, IdCard, Car, ChevronDown, ChevronUp } from "lucide-react";
import { compactPlate } from "./DocumentArchive";

export function missingDocs(customer, policies, vehicles, docs) {
  if (!docs) return [];
  const plates = new Set([
    ...policies.filter((p) => p.customer === customer.name && !p.deletedAt).map((p) => compactPlate(p.plate)),
    ...vehicles.filter((v) => v.customer === customer.name).map((v) => compactPlate(v.plate)),
  ].filter((p) => p.length >= 5));
  const out = [];
  if (!docs.some((d) => d.category === "kimlik")) out.push({ category: "kimlik", label: "Kimlik belgesi eksik" });
  const ruhsats = docs.filter((d) => d.category === "ruhsat");
  plates.forEach((p) => {
    if (!ruhsats.some((d) => compactPlate(d.plate) === p || compactPlate(d.name).includes(p))) out.push({ category: "ruhsat", plate: p, label: `${p} ruhsatı eksik` });
  });
  return out;
}

export function MissingDocsAlert({ items, onFix }) {
  const [open, setOpen] = useState(false);
  if (!items.length) return null;
  const shown = open ? items : items.slice(0, 2);
  return (
    <div className="missing-docs" data-testid="missing-docs-alert">
      <AlertTriangle size={16} />
      <strong>Eksik belgeler <em data-testid="missing-docs-count">{items.length}</em></strong>
      <div className="missing-docs-list">
        {shown.map((m) => (
          <button key={`${m.category}-${m.plate || ""}`} type="button" onClick={() => onFix(m)} data-testid={`missing-doc-${m.category}${m.plate ? `-${m.plate}` : ""}`}>
            {m.category === "kimlik" ? <IdCard size={13} /> : <Car size={13} />} {m.label} · Yükle
          </button>
        ))}
        {items.length > 2 && (
          <button type="button" className="missing-docs-toggle" onClick={() => setOpen((o) => !o)} data-testid="missing-docs-toggle">
            {open ? <><ChevronUp size={13} /> Daralt</> : <><ChevronDown size={13} /> +{items.length - 2} daha göster</>}
          </button>
        )}
      </div>
    </div>
  );
}
